import { type DayPartEntries } from './daypart-entry';
import ParkingDayPartEntries from './parking-day-part-entry';
import type WorkplacesForDayPart from './workplaces-for-daypart';

class AgendaEntry {
  officeId?: string;

  isPresentAtLunch = false;

  isPresentAtWork = false;

  dayPartEntries: DayPartEntries[] = [];

  parkingDayPartEntries: ParkingDayPartEntries[] = [];

  date: Date = new Date();

  workplacesForDayparts?: WorkplacesForDayPart[];
}

export default AgendaEntry;
